import { render, staticRenderFns } from "./RegistrarAcceso.vue?vue&type=template&id=9dc6df84&scoped=true&"
import script from "./RegistrarAcceso.vue?vue&type=script&lang=js&"
export * from "./RegistrarAcceso.vue?vue&type=script&lang=js&"
import style0 from "./RegistrarAcceso.vue?vue&type=style&index=0&id=9dc6df84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc6df84",
  null
  
)

export default component.exports